// extracted by mini-css-extract-plugin
module.exports = {"star":"contentCreator_star__3s5-O","active":"contentCreator_active__27a92"};